// Backend API base URL.
//
// Default is empty string => `${API_BASE_URL}/api/...` becomes a relative
// `/api/...` request, which is same-origin in BOTH environments:
//   - dev:  CRA dev server proxies /api/* to Flask (see setupProxy.js)
//   - prod: nginx proxies /api/* to Gunicorn (see deploy/nginx-cms.conf)
//
// Override only when the backend lives on a different origin (rare).
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

// Feature flag: pricing page + nav link. Set to `true` to re-enable the pricing
// section (the /pricing route and its "Pricing" nav item). The PricingPage
// component itself is left intact so re-enabling is a one-line change.
export const PRICING_ENABLED = false;

// Copy text to the clipboard, resilient to non-secure contexts.
//
// The async Clipboard API (`navigator.clipboard`) is ONLY available in a secure
// context — HTTPS or localhost. When the app is served over plain HTTP (common
// on internal/prod hosts without TLS), `navigator.clipboard` is `undefined`, so
// `navigator.clipboard.writeText(...)` throws "Cannot read properties of
// undefined". We fall back to the legacy `execCommand('copy')` via a hidden
// textarea so Copy buttons keep working everywhere. Returns a Promise that
// resolves on success and rejects on failure.
export function copyToClipboard(text) {
  const value = text == null ? '' : String(text);
  // Prefer the async Clipboard API when it's actually available. On plain HTTP
  // (non-secure context) `navigator.clipboard` is undefined, so this guard is
  // what routes us to the legacy fallback instead of throwing.
  if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(value);
  }
  return new Promise((resolve, reject) => {
    try {
      const ta = document.createElement('textarea');
      ta.value = value;
      // Keep it off-screen and non-interactive so it doesn't disturb layout/focus.
      ta.style.position = 'fixed';
      ta.style.top = '0';
      ta.style.left = '-9999px';
      ta.setAttribute('readonly', '');
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      if (ok) resolve();
      else reject(new Error('Copy command was rejected by the browser'));
    } catch (err) {
      reject(err);
    }
  });
}